/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MagicLinkContext } from '../models/MagicLinkContext';
import type { PaginatedSignatureAuditEventList } from '../models/PaginatedSignatureAuditEventList';
import type { RequestSignatureInput } from '../models/RequestSignatureInput';
import type { SignatureRequest } from '../models/SignatureRequest';
import type { SignInput } from '../models/SignInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SignaturesService {

    /**
     * Token-scoped signing for a logged-out signer. The token authorizes access
     * to exactly one participant/document.
     * @returns MagicLinkContext
     * @throws ApiError
     */
    public static signaturesMagicLinkRetrieve({
        token,
    }: {
        token: string,
    }): CancelablePromise<MagicLinkContext> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/signatures/magic-link/{token}/',
            path: {
                'token': token,
            },
        });
    }

    /**
     * Token-scoped signing for a logged-out signer. The token authorizes access
     * to exactly one participant/document.
     * @returns any
     * @throws ApiError
     */
    public static signaturesMagicLinkCreate({
        token,
        requestBody,
    }: {
        token: string,
        requestBody: SignInput,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/signatures/magic-link/{token}/',
            path: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Session-authenticated signing endpoints, org-scoped by security context.
     * @returns SignatureRequest
     * @throws ApiError
     */
    public static signaturesRequestsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this signature request.
         */
        id: string,
    }): CancelablePromise<SignatureRequest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/signatures/requests/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Session-authenticated signing endpoints, org-scoped by security context.
     * @returns PaginatedSignatureAuditEventList
     * @throws ApiError
     */
    public static signaturesRequestsAuditList({
        id,
        limit,
        offset,
    }: {
        /**
         * A UUID string identifying this signature request.
         */
        id: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedSignatureAuditEventList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/signatures/requests/{id}/audit/',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * Session-authenticated signing endpoints, org-scoped by security context.
     * @returns any
     * @throws ApiError
     */
    public static signaturesRequestsRequestSignatureCreate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this signature request.
         */
        id: string,
        requestBody: RequestSignatureInput,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/signatures/requests/{id}/request-signature/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Session-authenticated signing endpoints, org-scoped by security context.
     * @returns SignatureRequest
     * @throws ApiError
     */
    public static signaturesRequestsSignCreate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this signature request.
         */
        id: string,
        requestBody: SignInput,
    }): CancelablePromise<SignatureRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/signatures/requests/{id}/sign/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Session-authenticated signing endpoints, org-scoped by security context.
     * @returns any
     * @throws ApiError
     */
    public static signaturesRequestsViewCreate({
        id,
    }: {
        /**
         * A UUID string identifying this signature request.
         */
        id: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/signatures/requests/{id}/view/',
            path: {
                'id': id,
            },
        });
    }

}
